import React from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from 'src/store';
import { selectNoteByContentId } from 'src/store/model/note';
import { List } from 'src/components/custom';
import { Note } from 'src/components/coreUI';

const NoteList: React.FC = () => {
  const { class_topic_content_id } =
    useParams<{ class_topic_content_id: string }>();
  const notes = useAppSelector((state) =>
    selectNoteByContentId(state, class_topic_content_id),
  );

  return (
    <List
      relaxed
      columns={1}
      data={notes}
      renderItem={(note) => <Note {...note} />}
    />
  );
};

export default NoteList;
